import { Injectable, effect, signal } from '@angular/core';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'unblockit-theme';

/**
 * Tema da plataforma (claro/escuro). O valor é refletido em
 * `document.documentElement[data-theme]` — o que comuta todos os tokens CSS —
 * e persistido em localStorage. Tema claro é o padrão (Direção A · Terminal).
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly theme = signal<Theme>(this.readInitial());

  constructor() {
    effect(() => {
      const value = this.theme();
      document.documentElement.dataset['theme'] = value;
      try {
        localStorage.setItem(STORAGE_KEY, value);
      } catch {
        /* storage indisponível: tema apenas em memória */
      }
    });
  }

  setTheme(theme: Theme): void {
    this.theme.set(theme);
  }

  toggle(): void {
    this.theme.update((current) => (current === 'dark' ? 'light' : 'dark'));
  }

  private readInitial(): Theme {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'dark' || stored === 'light') {
        return stored;
      }
    } catch {
      /* ignore */
    }
    return 'light';
  }
}
